import axios from "axios";
import { getCookie } from "../../getcookie";
// import { getCookie } from "../getcookie.js";

const apiUrl = process.env.REACT_APP_API_URL;
const gateApiUrl = process.env.REACT_APP_GATE_API_URL;

const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
const header = {
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*", // Required for CORS support to work
  Authorization: getCookie("mawalog"),
};

export const getalertConfigApi = async () => {
  try {
    const response = await axios.get(apiUrl + `get_alert_list`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getalertDetailsApi = async (label) => {
  try {
    const response = await axios.get(apiUrl + `alert_config/`, {
      headers: header,
    });
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const alertSubmitApi = async (data) => {
  try {
    const response = await axios.post(apiUrl + `alert_config`, data, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error submitting alert config:", err);
    throw err;
  }
};

//Delete
export const getDeleteFieldsApi = async (id) => {
  try {
    const response = await axios.delete(apiUrl + `alert_config/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error deleting alert config:", err);
    throw err;
  }
};

//List
export const getListApi = async (term) => {
  try {
    const response = await axios.get(apiUrl + "alert_config" + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching alert configs:", err);
    throw err;
  }
};

//Gate
export const getDockListApi = async (term) => {
  try {
    const response = await axios.get(apiUrl + "gatemaster/autosuggestion", {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching vendors:", err);
  }
};

//Update
export const updateConfigApi = async (id, data) => {
  try {
    const response = await axios.put(apiUrl + `alert_config/` + id, data, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error updating alert config:", err);
    throw err;
  }
};

//Edit

export const getEditConfigApi = async (id) => {
  try {
    const response = await axios.get(apiUrl + `alert_config/` + id, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const getGateListApi = async (term) => {
  try {
    const response = await axios.get(
      apiUrl + "gate/autosuggestion?term="+term,
      {
        headers: header,
      }
    );
    return response;
  } catch (err) {
    console.error("Error fetching vendors:", err);
  }
};

//Suggestionlist
export const getTypeListApi = async (term) => {
  try {
    const response = await axios.get(apiUrl + "alert_config/get_list?term=" + term, {
      headers: header,
    });
    return response;
  } catch (err) {
    console.error("Error fetching suggestion list:", err);
  }
};
